import { createSlice } from '@reduxjs/toolkit'

export const slice = createSlice({
    name: 'pagination',
    initialState: {
        pageName: null,
        selectedPage: 1,
        searchCriteria: {
            rrn: '', 
            orderId: '', 
            merchantSpecificData: '', 
            transactionCode: '', 
            amount: '', 
            email: '', 
            contactNumber: '', 
            transactionDate: '', 
            transactionState: '', 
            stan: '',
        }   
    },
    reducers: {
        resetPagination: (state) => {
            state = { pageName: null, selectedPage: 1 }
        },
        pageChange: (state, action) => {
            const { pageName, selectedPage } = action.payload
            state.pageName = pageName
            state.selectedPage = selectedPage
        },
        saveSearchCriteria: (state, action) => {
            const searchCriteriaToSet = action.payload
            // override search criteria
            state.searchCriteria = { ...state.searchCriteria ,...searchCriteriaToSet }
        }
    }
})

const { pageChange: _pageChange, } = slice.actions

// Action creators are generated for each case reducer function
export const { resetPagination, saveSearchCriteria } = slice.actions

export const pageChange = (pageName, selectedPage) => _pageChange({ pageName, selectedPage })



export const searchCriteriaSelector = store => store.pagination.searchCriteria


export default slice.reducer